export const normalizeText = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") return value.trim();
  return String(value).trim();
};

export const normalizeArray = (input) => {
  if (!input) return [];

  if (Array.isArray(input)) {
    return input
      .map((item) => normalizeText(item))
      .filter((item) => item.length > 0);
  }

  return normalizeText(input)
    .split(/\r?\n|[•●▪■\-–;]+/)
    .map((line) => line.trim())
    .filter((line) => line.length > 0);
};

